import { useContext } from 'react'
import { useAppConfig as useBriqCommonAppConfig } from '@briq/shared'

import { AppConfigContext } from '../config/configContext'

export function useAppConfig() {
  const briqCommonConfig = useBriqCommonAppConfig()
  const config = useContext(AppConfigContext)
  return { ...briqCommonConfig, ...config }
}
